import { lazy, Suspense } from 'react';

import WidgetLoading from 'common/components/widget/WidgetLoading';
import { retry } from 'common/helpers/routerHelper';

const LoadableComponent = lazy(() => retry(() => import('./BuyButtonWidget')));

const BuyButtonWidgetLoader = (props) => (
  <Suspense fallback={<WidgetLoading />}>
    {/* eslint-disable react/jsx-props-no-spreading */}
    <LoadableComponent {...props} />
  </Suspense>
);

export default BuyButtonWidgetLoader;
